jQuery(document).ready(function ($) {
    if (!$('body').hasClass('woocommerce-cart')) {
        return;
    }

    let ajax_plus_minus_timeout;
    const TIMEOUT_FOR_AJAX_UPDATING = 750;

    const container = $('.woocommerce');
    container.on('click', '.qty-button.decrease', function () {
        adjust_quantity_input($(this), -1);
    });

    container.on('click', '.qty-button.increase', function () {
        adjust_quantity_input($(this), 1);
    });

    const adjust_quantity_input = function (element, value) {
        const input = element.siblings('.quantity').find('input');
        const quantity = parseInt(input.val());
        if (value < 0) {
            const min = parseInt(input.attr('min'));
            if (min && (quantity - 1) < min) {
                return;
            }
            input.val(quantity - 1);
        } else if (value > 0) {
            const max = parseInt(input.attr('max'));
            if (max && (quantity + 1) > max) {
                return;
            }
            input.val(quantity + 1);
        }
        clearTimeout(ajax_plus_minus_timeout);
        ajax_plus_minus_timeout = setTimeout(function (e) {
            update_quantities_ajax();
        }, TIMEOUT_FOR_AJAX_UPDATING);
    };

    const update_quantities_ajax = function () {
        $("[name='update_cart']").prop('disabled', false).trigger("click");
    }

    $('div.woocommerce').on('change', 'input.qty', function () {
        update_quantities_ajax();
    });

});
